/* eslint-disable react/jsx-no-bind */

'use client'

import { Login } from '@acko-tech/building-blocks.ui.login'
import isMobile from 'ismobilejs'
import { r2d2 } from '@utils/utils'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { ThemeProvider } from 'styled-components'
import { AckoMainTheme } from '@acko-tech/building-blocks.ui.theme'
import { ModalDesktop, ModalMobile } from '@acko-tech/building-blocks.ui.modal'
import styles from './commonStyles.module.scss'
import VehicleBanner from './vehicleBanner'
import { EVENT_ERROR } from './commonConstants'
import { commonWidgetConfig } from './commonWidgetConfig'
import { SEGMENT } from './widgetSegments'
import { LoginModalProps } from './loginInterface'

const LoginModal = ({
  segmentEventCommonProperties,
  setUserLoggedIn,
  regNo,
  setIsLoginModal,
  widgetType,
}: LoginModalProps) => {
  function callR2d2(data) {
    const phoneNumber = data?.edata?.phone
    if (data?.ekind === 'otp_verified') {
      trackEvent(SEGMENT.OTP_ENTERED, {
        ...segmentEventCommonProperties,
        product: commonWidgetConfig.product[widgetType],
        phone: phoneNumber || '-',
        registration_number: regNo,
      }).catch(error => {
        console.error(EVENT_ERROR, error)
      })
    }
    return r2d2({}, `${window.location.origin}/api/r2d2/`)
  }
  const verifyOtpSuccess = () => {
    setUserLoggedIn(true)
    setIsLoginModal(false)
  }
  const renderLogin = () => (
    <>
      <VehicleBanner regNo={regNo} widgetType={widgetType} isLoginBanner />
      <Login
        callbackVerifyOTPSuccess={() => {
          verifyOtpSuccess()
        }}
        r2d2={callR2d2}
        track={() => {}}
        sitekey={SEGMENT.SIT_KEY}
        configName={commonWidgetConfig.configName[widgetType]}
        loginScreenWrapperHeight="20px"
      />
    </>
  )
  return (
    <ThemeProvider theme={AckoMainTheme}>
      {!isMobile()?.phone ? (
        <ModalDesktop
          show
          onHide={() => {
            setIsLoginModal(false)
          }}
          urlhash=""
          maxWidth="800px"
          minWidth="580px"
          padding="20px">
          {renderLogin()}
        </ModalDesktop>
      ) : (
        <ModalMobile show onHide={() => setIsLoginModal(false)} urlhash="" height="55%" showOverlayBackground>
          <div className={styles.loginMobile}>
          {renderLogin()}
          </div>
        </ModalMobile>
      )}
    </ThemeProvider>
  )
}

export default LoginModal
